import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../services/api';

const formatMoney = (value) => {
    if (value === null || value === undefined || value === '') return 'Not provided';
    const number = Number(value);
    if (Number.isNaN(number)) return 'Not provided';
    return `${number.toLocaleString('en-US')} EGP`;
};

const DetailRow = ({ label, value }) => (
    <div className="col-sm-6">
        <div className="mb-3">
            <strong>{label}:</strong> {value === null || value === undefined || value === '' ? 'N/A' : value}
        </div>
    </div>
);

const ViewResaleInterestModal = ({ show, handleClose, interest, onUpdated }) => {
    const [status, setStatus] = useState('pending');
    const [adminNotes, setAdminNotes] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setStatus(interest?.status || 'pending');
        setAdminNotes(interest?.adminNotes || '');
    }, [interest]);

    if (!interest) return null;

    const resaleUnit = interest.resale_unit || {};

    const handleSave = async () => {
        setSaving(true);
        try {
            await api.put(`/resaleInterests/${interest.id}`, { status, adminNotes });
            toast.success('Request updated successfully!');
            onUpdated?.();
            handleClose();
        } catch (error) {
            console.error('Error updating resale interest:', error);
            toast.error(error?.response?.data?.message || 'Failed to update the request.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Interest Request #{interest.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6 className="mb-3">Buyer</h6>
                <div className="row">
                    <DetailRow label="Name" value={interest.buyerName} />
                    <DetailRow label="Mobile" value={interest.buyerMobile} />
                    <DetailRow label="Email" value={interest.buyerEmail} />
                    <DetailRow label="App account" value={interest.user?.name} />
                    <DetailRow label="Available cash" value={formatMoney(interest.availableCash)} />
                    <DetailRow label="Comfortable installment" value={formatMoney(interest.comfortableInstallment)} />
                </div>
                {interest.message && (
                    <div className="mb-3">
                        <strong>Message:</strong> {interest.message}
                    </div>
                )}

                <hr />
                <h6 className="mb-3">Requested unit</h6>
                <div className="row">
                    <DetailRow label="Resale unit" value={resaleUnit.id ? `#${resaleUnit.id}` : null} />
                    <DetailRow label="Developer" value={resaleUnit.developerName} />
                    <DetailRow label="Project" value={resaleUnit.projectName} />
                    <DetailRow label="Type" value={resaleUnit.type} />
                    <DetailRow label="Location" value={resaleUnit.location} />
                    <DetailRow label="Area" value={resaleUnit.area ? `${resaleUnit.area} m²` : null} />
                    <DetailRow label="Contract price" value={formatMoney(resaleUnit.contractPrice)} />
                    <DetailRow label="Cash to seller" value={formatMoney(resaleUnit.paidAmount)} />
                    <DetailRow label="Remaining to developer" value={formatMoney(resaleUnit.remainingAmount)} />
                    <DetailRow label="Our commission (buyer)" value={formatMoney(resaleUnit.buyerCommissionAmount)} />
                    <DetailRow label="Seller" value={resaleUnit.sellerName} />
                    <DetailRow label="Seller number" value={resaleUnit.sellerMobile} />
                </div>

                <hr />
                <h6 className="mb-3">Follow up</h6>
                <div className="mb-3">
                    <label htmlFor="resaleInterestStatus" className="form-label">
                        Status
                    </label>
                    <select
                        id="resaleInterestStatus"
                        className="form-select"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <option value="pending">Pending</option>
                        <option value="contacted">Contacted</option>
                        <option value="closed">Closed</option>
                        <option value="cancelled">Cancelled</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="resaleInterestNotes" className="form-label">
                        Internal notes
                    </label>
                    <textarea
                        id="resaleInterestNotes"
                        className="form-control"
                        rows={3}
                        value={adminNotes}
                        onChange={(e) => setAdminNotes(e.target.value)}
                        placeholder="What happened on the call, next steps, ..."
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewResaleInterestModal;
